<template>
  <Layout>
    <b-overlay :show="isLoading" rounded="sm">
    <div class="card">
      <div class="card-body">
        <PageHeader :title="title" :items="items" />
        <div class="container">
          <div class="card mt-4">
            <div class="form-row big-font">
              <div class="form-group col-md-4">
                <label>Oficina</label>
                <v-select :options="user.oficinas"
                          label="descripcion"
                          v-model="oficina_seleccionada"
                />
              </div>
              <div class="form-group col-md-4">
                <label>Tipo documento</label>
                <v-select :options="documentos_tipos"
                          label="descripcion"
                          v-model="documento_seleccionado"


                />

              </div>
            </div>

          </div>
          <div class="row">
            <h5>Numero siguiente:</h5>
          </div>
          <div class="row">
            <div class="col-md-3">
              <h1 class="p-5 border">{{numero_siguiente}}</h1>
            </div>
            <div class="form-group col-md-4">
              <input class="form-control" v-model="descripcion" placeholder="Ingrese una breve descripción"/>
            </div>
            <div class="col-md-2">
              <button class="btn btn-primary" v-on:click="reservar()">Reservar</button>
            </div>

          </div>
          <div class="row">
            <table class="table">
              <thead>
                <th>Oficina</th>
                <th>Documento</th>
                <th>Numeracion</th>
                <th>Descripción</th>
                <th>Usuario</th>
                <th>Fecha</th>
                <th>OP</th>

              </thead>
              <tbody>
                <tr v-for="(data,index) in lista_numeracion"  v-bind:key="index" >
                  <td>{{data.oficina}}</td>
                  <td>{{data.documento}}</td>
                  <td>{{data.numero}}</td>
                  <td>{{data.descripcion}}</td>
                  <td>{{data.usuario}}</td>
                  <td>{{data.created_at}}</td>
                  <td> <button class="btn btn-primary btn-icon btn-sm" v-on:click="editarNumeracion(data.id)"><i class="fa fa-edit"></i></button></td>
                </tr>
              </tbody>
            </table>
          </div>


        </div>



      </div>
    </div>

      <b-modal
              id="modal"
              scrollable
              title="numeracion"
              title-class="font-18"
              size="lg"
              @ok="editarNumeracionGuardar"
      >
        <div class="form-row">
          <div class="form-group col-md-8">
            <label>Descripcion</label>
            <input class="form-control" v-model="model.descripcion">

          </div>
        </div>

      </b-modal>
    </b-overlay>

  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";


/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Expedientes",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,


  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    oficina_seleccionada: function (val) {
      this.lista();
    },
    // eslint-disable-next-line no-unused-vars
    documento_seleccionado: function (val) {
      this.lista();
    }
  },
  data() {
    return {
      lista_numeracion:[],
      documentos_tipos:[],
      user:{},
      model:{},
      title: "Númeracion de documentos",
      items: [
        {
          text: "Numeracion documentos",
          href: "/"
        },
        {
          text: "Numeracion",
          active: true
        }
      ],
      isLoading: false,
      server: process.env.VUE_APP_BACKEND,
      modal:{},
      descripcion:'',
      numero_siguiente:'-',
      oficina_seleccionada:null,
      documento_seleccionado:null
    };
  },
  mounted() {

    this.user=JSON.parse(localStorage.getItem('user'));
    this.axios.get(process.env.VUE_APP_BACKEND+'/api/documento-tipo')
    .then((response)=>{
      this.documentos_tipos=response.data;
    });
  },

  methods: {

    editarNumeracion(id){
      this.isLoading=true;
      this.axios.get(process.env.VUE_APP_BACKEND+'/api/numeracion/'+id)
              // eslint-disable-next-line no-unused-vars
              .then((response)=>{
                this.model=response.data;
                this.$bvModal.show("modal");
              })
              // eslint-disable-next-line no-unused-vars
              .catch((error)=>{
                this.$swal('Error','Error intente de nuevo','warning');
                this.isLoading=false;
              })
              .finally(()=>this.isLoading=false);
    },
    editarNumeracionGuardar(){
      this.isLoading=true;
      this.axios.post(process.env.VUE_APP_BACKEND+'/api/numeracion',this.model)
              // eslint-disable-next-line no-unused-vars
              .then((response)=>{
                this.lista();
                this.$bvModal.hide("modal");
              })
              // eslint-disable-next-line no-unused-vars
              .catch((error)=>{
                this.$swal('Error','Error intente de nuevo','warning');
                this.isLoading=false;
              });
    },
    reservar(){
      var numero;
      if(this.oficina_seleccionada==null || this.documento_seleccionado==null)
      {
        this.$swal('Cuidado','Seleccione la oficina y documento','warning');
        return;
      }
      this.isLoading=true;
      numero=this.numero_siguiente;
      this.axios.post(
              process.env.VUE_APP_BACKEND+'/api/reservar',
          {
                  'oficina_id':this.oficina_seleccionada.id,
                  'documento_tipo_id':this.documento_seleccionado.id,
                  'numero_siguiente':this.numero_siguiente,
                  'descripcion':this.descripcion
                }

      )
              .then((response)=>{

                this.lista_numeracion=response.data.data;
                this.numero_siguiente=response.data.numero_siguiente;
                if(response.data.success)
                {
                  // eslint-disable-next-line no-unused-vars
                  let instance = this.$toast.open(
                          {
                          message:'<div class="font-size-24">Se reservo la numeracion: '+numero+'</div>',
                            type: 'info'
                          }
                  );
                }
                else
                {
                  this.$swal('Cuidado','Ya se ocupo esa numeracion, intente de nuevo.','warning');

                }





              })
              // eslint-disable-next-line no-unused-vars
              .catch((error)=>{
                this.$swal('Error','Error intente de nuevo','warning');
                this.isLoading=false;
              })
              .finally(()=>this.isLoading=false);
    },

    lista(){
      if(this.oficina_seleccionada!=null && this.documento_seleccionado!=null)
      {
        this.isLoading=true;
        this.axios.get(
                process.env.VUE_APP_BACKEND+'/api/documento-tipo-lista',
                {
                  'params' : {
                    'oficina_id':this.oficina_seleccionada.id,
                    'documento_tipo_id':this.documento_seleccionado.id
                  }

                }
        )
      .then((response)=>{
        if(response.data.success)
        {
          this.lista_numeracion=response.data.data;
          this.numero_siguiente=response.data.numero_siguiente;
        }

        })
        .finally(()=>this.isLoading=false);
      }
      else
      {
        this.lista_numeracion=[];
        this.numero_siguiente='-';
      }

    }

    /* eslint-enable */
  },

};
</script>

<style>
.fixtable {
  color: #000000 !important;
}
</style>
